import React from "react";
import { useEffect, useState } from "react";
import { makeIntToDaysOfWeekArray } from "../utils";
import PropTypes from "prop-types";
import { useTextResources, useMessageResources } from "../../../language";
import { weekDays } from "../constants";

const Weekdays = ({selectedWeekdaysInt = 0, importedSelectedWeekDaysArray, onlyChosenDays = false}) => {
    const text = useTextResources();
    const msg = useMessageResources();

    const [selectedWeekDaysArray, setSelectedWeekDaysArray] = useState([]);

    useEffect(() => {
        if(importedSelectedWeekDaysArray)
            setSelectedWeekDaysArray(importedSelectedWeekDaysArray);
        else if(selectedWeekdaysInt || selectedWeekDaysArray === 0)
            setSelectedWeekDaysArray(makeIntToDaysOfWeekArray(selectedWeekdaysInt));
    }, [selectedWeekdaysInt,importedSelectedWeekDaysArray]);

    if (onlyChosenDays) {
        if (selectedWeekDaysArray.length === 0) {
          return <span>{msg("NoDaysWereChosen")}</span>;
        }

        return selectedWeekDaysArray.map((dayIndex, index) => (
          <span key={dayIndex}>
            {text(weekDays[dayIndex])}
            {index === selectedWeekDaysArray.length - 1 ? "" : ", "}
          </span>
        ));
      }

    return weekDays.map((weekDay, index) => <span style={{fontWeight: selectedWeekDaysArray.indexOf(index) === -1? "normal": "bold"}} key={index}>{text(weekDay)}{index === 6? "": ", "}</span>)
}

Weekdays.propTypes = {
    selectedWeekdaysInt: PropTypes.number,
    importedSelectedWeekDaysArray: PropTypes.array,
    onlyChosenDays: PropTypes.bool,
  };


export default Weekdays;
